const state = {
	toast: null,
};

const mutations = {
	toast: (state, payload) => (state.toast = payload),
};

export default { state, mutations };
